export async function takeScreenshot(url: string): Promise<string> {
  try {
    // Construct the Microlink API URL
    const apiUrl = new URL('https://api.microlink.io');
    const params = {
      url: url,
      screenshot: 'true',
      meta: 'false',
      embed: 'screenshot.url',
      'viewport.width': '1280',
      'viewport.height': '720',
      waitUntil: 'networkidle2'
    };

    // Add parameters to URL
    Object.entries(params).forEach(([key, value]) => {
      apiUrl.searchParams.append(key, value);
    });

    // Use the API URL directly as the image source
    return apiUrl.toString();
  } catch (error) {
    console.error('Screenshot generation failed:', error);
    throw new Error('Failed to generate screenshot');
  }
}
